<template>
    <template v-if="isAppLoaded">
        <!-- DEPRECATED. Refactor routing to new style -->
        <component v-if="layout" :is="layout" :class="{'app_hidden' : searchOverflow}">
            <router-view v-slot="{ Component }">
                <transition name="scale" mode="out-in">
                    <component :is="Component"/>
                </transition>
            </router-view>
        </component>

        <!-- New style -->
        <router-view v-else v-slot="{ Component }">
            <transition name="scale" mode="out-in">
                <component :is="Component"/>
            </transition>
        </router-view>
    </template>
    <Spinner v-else size="4rem"/>
    <!-- <Spinner class="load" v-else/> -->
</template>
<script>
import {mapActions, mapGetters, mapMutations, useStore} from 'vuex'
import {watch, ref, nextTick} from 'vue'
import {initMyTrackerMetric} from '@/script/myTrackerMetric'
import Spinner from '@/components/Spinner.vue'
import {getValidToken} from "@/script/storageToken";
import {useI18n} from "vue-i18n";


export default {
    components: {Spinner},
    computed: {
        ...mapGetters(['user', 'searchOverflow']),
        /**
         * @description Выбираем layout в зависимости от данных из роута
         */
        layout() {
            // return (this.$route.meta.layout || 'default')
            return (this.$route.meta.layout ?? null)
        }
    },
    setup() {
        initMyTrackerMetric()

        const isAppLoaded = ref(false)
        return {

            isAppLoaded
        }
    },
    methods: {
        ...mapActions(['getUserData', 'getCourses', 'getAllCategories', 'getNotification', 'getUserMessages', 'fetchCustomInfo', 'getBackendStatus']),
        ...mapMutations(['setInfo', 'setBackendStatus']),
      async checkUser() {
        const token = getValidToken()

        if (!token) {
          this.isAppLoaded = true

          return
        }

        try {
          if (!this.user) {
            await this.getUserData()
            this.$i18n.locale = this.user.lang
            await this.getNotification()
          }

          const windowLocation = window.location.pathname
          if (this.user && (windowLocation === '/auth' || windowLocation === '/')) {
            this.$router.push('/courses')
          }

        } catch (e) {
          console.warn(e)
        } finally {
          this.isAppLoaded = true
        }
      },
        async loadCustomInfo() {
            await this.fetchCustomInfo()
        },
        async loadBackendStatus() {
            await this.getBackendStatus()
        }
    },
    created() {
        this.checkUser()
        this.loadBackendStatus()
        this.loadCustomInfo()
    }
}
</script>

<style lang="scss">
// @import '@/assets/scss/common/main.scss';
</style>

<style scoped>
</style>
